import { createContext } from 'react'

const FetchContext = createContext()

export default FetchContext
